import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { GoalInputModalPage } from './goal-input-modal.page';

const routes: Routes = [
  {
    path: '',
    component: GoalInputModalPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class GoalInputModalPageRoutingModule {}
